export default {
  layout: 'empty',
  mounted() {
    // necessary for reverse proxy to kick in
    window.location.reload();
  }
};